import { Component, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { policySections } from './policy.component.interface';
import { Location } from '@angular/common';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PolicyComponent {
  protected readonly policySections = policySections;
  toggle: boolean = false;

  constructor(private location: Location) {}

  sidebarToggle() {
    setTimeout(() => {
      this.toggle = !this.toggle;
    }, 25);
  }

  goBack(): void {
    this.location.back();
  }
}
